import type { RouteObject } from 'react-router-dom'

export const cardContentEditorRoutes: RouteObject[] = [
  {
    path: 'card-sets/:cardSetId/cards/add',
    lazy: () => import('../../features/content/ui/CardContentEditorRoute'),
  },
  {
    path: 'card-sets/:cardSetId/cards/:cardId/edit',
    lazy: () => import('../../features/content/ui/CardContentEditorRoute'),
  },
]
